const registration = {
  recurlyToken: $form => {
    window.recurly.token($form[0], (err, token) => {
      if (err) {
        $('#server_errors_display').removeClass('hidden');
        $('#server_errors_text').html(err.message);

        $form
          .find('.js-credit_submit')
          .attr('disabled', false)
          .text(registration.getSubmitText());
      } else {
        registration.callSubscribeOnFront(token, $form);
      }
    });
  },
  paypalRecurlyToken: $form => {
    const options = {
      description: 'Woorank Subscription',
      country: $form.find('#countries_select').val()
    };

    $form.addClass('hidden');
    $('#waiting_for_paypal').removeClass('hidden');

    window.recurly.paypal(options, (err, token) => {
      if (err) {
        $('#server_errors_display').removeClass('hidden');
        $('#server_errors_text').html(err.message);
        $form.removeClass('hidden');
        $('#waiting_for_paypal').removeClass('hidden');
      } else {
        registration.callSubscribeOnFront(token, $form);
      }
    });
  },
  callSubscribeOnFront: (token, $form) => {
    const lang = window.wooGlobal.language;
    const planCode = $form.find('#plan_code').val();
    const couponCode = $form.find('#coupon_code').val();
    const accountCode = $form.find('#account_code').val();
    const email = $form.find('#email_field').val();
    const firstName = $form.find('#first_name_field').val();
    const lastName = $form.find('#last_name_field').val();
    const companyName = $form.find('#company_name_field').val();
    const countryCode = $form.find('#countries_select').val();
    const vatNumber = $form.find('#vat_field').val();
    const currency = $form.find('#currency').text();
    const creditCard = $form
      .find('.card_option')
      .hasClass('selected') ? 1 : 0;
    const recurlyToken = token.id;

    $.post('/' + lang + '/recurly/subscribe', {
      plan_code: planCode,
      coupon_code: couponCode,
      account_code: accountCode,
      email: email,
      first_name: firstName,
      last_name: lastName,
      company_name: companyName,
      country_code: countryCode,
      vat_number: vatNumber,
      credit_card: creditCard,
      recurly_token: recurlyToken,
      currency: currency
    }, function (response) {
      if (!response.data) {
        return;
      }

      if (response.data.success === true) {
        window.location = $form.attr('action');
      } else {
        $('#server_errors_display').removeClass('hidden');
        $('#server_errors_text').html(response.data.validationErrors);

        $form.find('.js-credit_submit')
          .attr('disabled', false)
          .text(registration.getSubmitText());
      }
    });
  },
  getSubmitText: () => {
    const isUpdatePayment = window.location.pathname.match('updatepayment') !== null;
    const isAddBilling = window.location.pathname.match('addbilling') !== null;
    let submitText = $('#start_free_trial').text();
    if (isUpdatePayment) {
      submitText = $('#update_payment_method').text();
    }
    if (isAddBilling) {
      submitText = $('#add_billing').text();
    }

    return submitText;
  }
};

module.exports = registration;
